import IClerk, { IClerkResponse } from "@/types/clerk";

const getters = {
  clerk: (state: IClerk): IClerkResponse => state.clerk,
  clerkJwt: (state: IClerk): string => {
    if (state.jwt) {
      return `${state.jwt}`;
    }
    return "";
  },
  canMakeSales: (state: IClerk): boolean => {
    return state.clerk?.canPerformSales && !state.clerk?.reachedSalesLimits;
  },
};

export default getters;
